
import Vue from "vue";
import Component from "vue-class-component";
import { Chrome } from "vue-color";
import { Prop, Watch } from "vue-property-decorator";
import { isLightColor, generatePalette } from "@/lib/singularity/brand/colors/palettes";
import clipboardCopy from "clipboard-copy";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: {
    Chrome,
    NiceButton
  }
})
export default class BrandColorPicker extends Vue {
  @Prop()
  color!: string;

  internalColor = this.color;
  isOverlayOpen = false;
  palette = generatePalette(this.internalColor);

  get classes() {
    return {
      "is-light": isLightColor(this.internalColor)
    };
  }

  updateColor(newColor: { hex: string }) {
    this.internalColor = newColor.hex;
    this.palette = generatePalette(newColor.hex);
    this.$emit("update", newColor.hex);
  }

  get inlineStyles() {
    return {
      backgroundColor: this.internalColor,
      color: isLightColor(this.internalColor)
        ? String(this.palette.scale[900].value)
        : String(this.palette.scale[100].value)
    };
  }

  copyColor(string: string) {
    clipboardCopy(string);
  }

  @Watch("color")
  onColorChange(newColor: string) {
    this.internalColor = newColor;
    this.palette = generatePalette(newColor);
  }
  mounted() {
    this.palette = generatePalette(this.internalColor);
  }
}
